import React, { useState, useEffect } from 'react';
import { Search } from 'lucide-react';
import { heroImg } from '../assets/assets';
import { useNavigate } from 'react-router-dom';



const DesktopHero = ({ searchTerm, onSearchChange, onKeyDown, onSearch }) => (
  <section className="bg-[#174568] text-white py-20 px-10">
    <div className="container mx-auto flex">
      {/* Left Content */}
      <div className="w-1/2 pr-10">
        <h1 className="text-5xl font-bold leading-tight mb-6">
          Hire the best programming &amp; Tech Expert for your project right here, right now.
        </h1>

        <p className="text-blue-100 mb-8">
          Our platform makes it effortless to discover and hire top-notch tech
          expert, with a wide range of skills and expertise, you can easily find the
          perfect match for your project.
        </p>

        <div className="grid grid-cols-2 gap-8 mb-12">
          <div>
            <h3 className="text-xl font-semibold mb-2">Efficient</h3>
            <p className="text-blue-100">
              Access a pool of highly skilled tech experts ready to tackle your projects.
            </p>
          </div>

          <div>
            <h3 className="text-xl font-semibold mb-2">Reliable</h3>
            <p className="text-blue-100">
              Trust in our platform to connect you with experienced and reliable tech expert.
            </p>
          </div>
        </div>

        <div className="relative">
          <input
            type="text"
            placeholder="Tell us what you need"
            className="w-full rounded-full py-3 px-6 pr-28 text-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-500"
            value={searchTerm}
            onChange={onSearchChange}
            onKeyDown={onKeyDown}
          />
          <button
            className="absolute right-0 top-0 bottom-0 bg-[#174568] text-white rounded-full px-6 mr-px my-px hover:bg-gray-800 transition-colors"
            onClick={onSearch}
          >
            Get started
          </button>
          <div className="absolute left-1 top-0 bottom-0 flex items-center pointer-events-none">
            <Search size={20} className="text-gray-400" />
          </div>
        </div>
      </div>

      {/* Right Images */}
      <div className="w-1/2 relative">
        <img src={heroImg} draggable={false} alt="Hero" />
      </div>
    </div>
  </section>
);

const MobileHero = ({ searchTerm, onSearchChange, onKeyDown, onSearch }) => (
  <section className="bg-[#174568] text-white pb-10">
    {/* Content */}
    <div className="px-6 pt-10">
      <h1 className="text-3xl font-bold leading-tight mb-6">
        Hire the best programming &amp; Tech Expert for your project right here, right now.
      </h1>

      {/* Images */}
      <div className="relative my-8 h-[280px] w-full">
        <img src={heroImg} draggable={false} className="h-full w-[80%] mx-auto" alt="Hero" />
      </div>

      <p className="text-blue-100 mb-6">
        Our platform makes it effortless to discover and hire top-notch tech
        expert, with a wide range of skills and expertise, you can easily find the
        perfect match for your project.
      </p>

      <div className="space-y-6 mb-8">
        <div>
          <h3 className="text-lg font-semibold mb-1">Efficient</h3>
          <p className="text-blue-100 text-sm">
            Access a pool of highly skilled tech experts ready to tackle your projects.
          </p>
        </div>

        <div>
          <h3 className="text-lg font-semibold mb-1">Reliable</h3>
          <p className="text-blue-100 text-sm">
            Trust in our platform to connect you with experienced and reliable tech expert.
          </p>
        </div>
      </div>

      <div className="relative">
        <div className="flex items-center border border-gray-300 bg-white rounded-full overflow-hidden focus-within:ring-2 focus-within:ring-blue-500">
          <div className="pl-4">
            <Search size={18} className="text-gray-400" />
          </div>
          <input
            type="text"
            placeholder="Tell us what you need"
            className="w-full py-3 px-2 text-gray-800 text-sm focus:outline-none bg-transparent"
            value={searchTerm}
            onChange={onSearchChange}
            onKeyDown={onKeyDown}
          />
          <button
            className="bg-[#174568] text-white text-sm rounded-full px-4 py-2 mr-1 whitespace-nowrap hover:bg-gray-800 transition-colors"
            onClick={onSearch}
          >
            Get started
          </button>
        </div>
      </div>
    </div>
  </section>
);

// ─── Main Hero component ────────────────────────────────────────────────────

const Hero = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleSearch = () => {
    if (searchTerm.trim()) {

      window.location.href = `/category/all-services?search=${encodeURIComponent(searchTerm.trim())}`;

    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const sharedProps = {
    searchTerm,
    onSearchChange: handleSearchChange,
    onKeyDown: handleKeyDown,
    onSearch: handleSearch,
  };

  return isMobile ? <MobileHero {...sharedProps} /> : <DesktopHero {...sharedProps} />;
};

export default Hero;